module.exports = __webpack_public_path__ + "img/logo-close-menu.d0426347.png";